import { Switch, Typography } from "@hellocarbo/lasagne";
import { useTranslation } from "react-i18next";

import { TCategory, TSubCategoryStatus } from "@/types";

import Card from "../ui/Card";

type SimulationCategoryProps = {
  category: TCategory;
  subCategories: TSubCategoryStatus;
  inputName: string;
  onChange: (newSubCategory: TSubCategoryStatus) => void;
};

function SimulationCategory({
  category,
  subCategories,
  inputName,
  onChange,
}: SimulationCategoryProps) {
  const { t } = useTranslation(["categories"]);

  return (
    <Card className="border-grayscale-xx-light p-md border">
      <Typography as="h3" weight="bold" className="mb-sm">
        {t(`categories:${category}`)}
      </Typography>
      <div className="gap-y-xs flex flex-col">
        {Object.keys(subCategories).map((subCategory) => {
          const subCategoryState = subCategories[subCategory];
          return (
            <Typography
              as="label"
              weight="semibold"
              className="text-grayscale-dark flex justify-between"
              key={subCategory}
            >
              {t(`categories:${subCategory}`)}
              <Switch
                name={inputName}
                value={subCategory}
                checked={subCategoryState}
                onCheckedChange={(checked) =>
                  onChange({ [subCategory]: checked })
                }
              />
            </Typography>
          );
        })}
      </div>
    </Card>
  );
}

export default SimulationCategory;
